module.exports = __webpack_public_path__ + "5897ecc9da2a44216df4fded973c14c0.svg";